module.exports = __webpack_public_path__ + "img/alf_day.a2a775a6.jpg";